"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.DocumentType = void 0;
var pages_1 = require("./pages");
var OthersType;
(function (OthersType) {
    OthersType["BAR_CHART"] = "bar_chart";
    OthersType["CONTACT"] = "contact";
    OthersType["PROFILE"] = "profile";
    OthersType["FOOTER"] = "footer";
    OthersType["HEADER"] = "header";
    OthersType["INVESTORS_DASHBOARD"] = "investors_dashboard";
    OthersType["INVESTORS_MATRIX"] = "investors_matrix";
    OthersType["INVESTORS_MENU"] = "investors_menu";
    OthersType["INVESTORS_TAB_CONTENT"] = "investors_tab_content";
    OthersType["INVESTORS_TABLE"] = "investors_table";
    OthersType["NEWSROOM"] = "newsroom";
    OthersType["PIE_CHART"] = "pie_chart";
    OthersType["PRESS_RELEASE"] = "press_release";
})(OthersType || (OthersType = {}));
// eslint-disable-next-line @typescript-eslint/no-redeclare
exports.DocumentType = __assign(__assign({}, pages_1.PageType), OthersType);
//# sourceMappingURL=document-type.js.map